import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {I18nModule} from "../../i18n/i18n.module";
import {BigBreadcrumbsComponent} from "./big-breadcrumbs.component";
import {MinifyMenuComponent} from "./minify-menu.component";
import {NavigationComponent} from "./navigation.component";
import {SmartMenuDirective} from "./smart-menu.directive";
import {UserModule} from "../../user/user.module";
import {RouterModule} from "@angular/router";
import {SharedModule} from "../../shared.module";
import { CollapseMenuComponent } from "../header";
import { ModalVentasModule } from "app/+tickets/folder/modal-ventas/modal-ventas.module";
import { SmartadminModule } from "../../../shared/smartadmin.module";
import { SmartadminInputModule } from "../../../shared/forms/input/smartadmin-input.module";
import { SmartadminLayoutModule } from "../layout.module";
// import {ChatModule} from "../../chat/chat.module";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    UserModule,
    SharedModule,
    ModalVentasModule,
    // ChatModule
  ],
  declarations: [
    BigBreadcrumbsComponent,
    MinifyMenuComponent,
    NavigationComponent,
    SmartMenuDirective,
    CollapseMenuComponent
  ],
  exports: [
    BigBreadcrumbsComponent,
    MinifyMenuComponent,
    NavigationComponent,
    SmartMenuDirective,
  ]
})
export class NavigationModule{}
